module.exports = __webpack_public_path__ + "static/media/CSV.17a33604.svg";